var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":_vm.loading_type}})
}
var staticRenderFns = []

export { render, staticRenderFns }